// src/app/features/brand/brandService.js
import axios from "axios";
import { base_url } from "../../../utils/axiosConfig";

/**
 * ✅ BRAND API SERVICE (ONLY)
 * - getBrands
 * - getABrand
 * - normalizes API response shapes
 */

const normalizeList = (response) => {
  // supports:
  // - response.data = []
  // - response.data = { data: [] }
  // - response.data = { brands: [] }
  // - response itself already an array (rare)
  if (Array.isArray(response)) return response;

  const data = response?.data;

  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.brands)) return data.brands;

  // fallback: if backend returns something odd, keep safe array
  return [];
};

export const getBrands = async () => {
  const response = await axios.get(`${base_url}brand`);
  return normalizeList(response);
};

export const getABrand = async (id) => {
  const response = await axios.get(`${base_url}brand/${id}`);
  return response?.data;
};

export const brandService = {
  getBrands,
  getABrand,
};